<dasch-swiss-advanced-search
  [uuid]="uuid"
  (emitGravesearchQuery)="onSearch($event)"
  (emitBackButtonClicked)="onBackClicked()"></dasch-swiss-advanced-search>
